import React from 'react'
import {Box, Image, Text, HStack, VStack, Center} from '@chakra-ui/react';
import { Badge } from '@chakra-ui/react'
import Header from './Header';
import Footer from './Footer';
import '../css/Skills.css';
import { FadeTransform } from 'react-animation-components';


// function Card(){
//     return(
//         <Box w='400px' m='10px' rounded='20px' overflow='hidden' boxShaddow='sm' bg='gray.200'>
//             <Image src={img1} alt="Course"></Image>
//             <Box p={5} bg='gray.200'>
//                 <Badge variant='solid' variantColor='teal' rounded='full'>NEW</Badge>
//                 <Badge colorScheme='green'>Success</Badge>
//                 <Text
//                     textTransform='uppercase'
//                     fontSize='sm'
//                     color='gray.500'
//                     letterSpacing='wide'>
//                     2 Hours &bull; 12 lectures
//                 </Text>
//                 <Text as='h2' fontWeight='semibold' fontSize='xl' my={2}>
//                     Introduction to chakra-ui
//                 </Text>
//             </Box>
//         </Box>
//     )
// }
function skills() {
  return (
    <div>
        <Header/>
        <FadeTransform
            in
            transformProps={{
                exitTransform: 'scale(0.5) translateY(-50%)'
            }}>
            <Center>
                <VStack spacing="20px">
                    <div class="heading">
                        Skills
                    </div>
                    <HStack>
                        <div className="icons">
                        <Image src="https://raw.githubusercontent.com/devicons/devicon/master/icons/bootstrap/bootstrap-plain-wordmark.svg" alt="Bootstrap" width="120" height="120" m="8px"/> 
                        <Image src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/java/java-original-wordmark.svg" alt="Java" width="120" height="120" m="8px"/> 
                        <Image src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/cplusplus/cplusplus-original.svg" alt="C++" width="120" height="120" m="8px"/> 
                        <Image src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/c/c-original.svg" alt="C" width="120" height="120" m="8px"/> 
                        <Image src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/html5/html5-original-wordmark.svg" alt="HTML5" width="120" height="120" m="8px"/> 
                        <Image src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/css3/css3-original-wordmark.svg" alt="CSS3" width="120" height="120" m="8px"/> 
                        <Image src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/flask/flask-original.svg" alt="Flask" width="120" height="120" m="8px"/> 
                        <Image src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/javascript/javascript-original.svg" alt="JavaScript" width="120" height="120" m="8px"/>     
                        <Image src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/mysql/mysql-original-wordmark.svg" alt="MySQL" width="120" height="120" m="8px"/> 
                        <Image src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/opencv/opencv-original.svg" alt="OpenCV" width="120" height="120" m="8px"/> 
                        <Image src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/pandas/pandas-original-wordmark.svg" alt="Pandas" width="120" height="120" m="8px"/> 
                        <Image src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/python/python-original.svg" alt="Python" width="120" height="120" m="8px"/> 
                        <Image src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/tensorflow/tensorflow-original.svg" alt="Tensorflow" width="120" height="120" m="8px"/> 
                        <Image src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/git/git-original-wordmark.svg" alt="Git" width="120" height="120" m="8px"/> 
                        <Image src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/github/github-original-wordmark.svg" alt="Github" width="120" height="120" m="8px"/> 
                        <Image src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/react/react-original.svg" alt="React" width="120" height="120" m="8px"/> 
                        </div>
                    </HStack>
                </VStack>
            </Center>
        </FadeTransform>
        <Footer/>
    </div>
  )
}

export default skills